export default "__VITE_ASSET__DX5QJcv7__"